import { MealPlanningSessionsIntentNavigate } from "@corpuscomplete/web/modules/common/components/scope-intent-navigate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/meal-planning-sessions/")({
  component: MealPlanningSessionsIntentNavigate,
});
